import type { JSX } from 'react'

import { useUserContext } from 'contexts/UserProvider'
import { ClientSelection } from 'screens/ClientSelection'
import { DownloadScreen } from 'screens/DownloadScreen'
import { LoginScreen } from 'screens/LoginScreen'

export const App = (): JSX.Element => {
  const { token, context } = useUserContext()

  return token ? context ? <DownloadScreen /> : <ClientSelection /> : <LoginScreen />
}
